import axios from 'axios';
import { auth, resError } from '@services/Helpers/ServiceInterceptor';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/VReportsCommission/',
});

api.interceptors.request.use((config) => auth(config));
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => resError(error)
);

class VReportsCommission {
  constructor() {
    if (!VReportsCommission.instance) {
      VReportsCommission.instance = this;
    }
    return VReportsCommission.instance;
  }

  search = (filters, orderBy, orderDir, p, fields, perPage) => {
    return api.post('/search', {
      filters: Object.keys(filters).length > 0 ? filters : {},
      orderBy,
      orderDir,
      page: p,
      fields: undefined,
      perPage: parseInt(perPage),
    });
  };

  create = (entity) => {
    return api.post('/', entity);
  };

  read = (id) => {
    return api.get('/' + id);
  };

  update = (entity) => {
    return api.put('/', entity);
  };

  delete = (id) => {
    return api.delete('/' + id);
  };

  export = (filters, orderBy, orderDir, p, fields, perPage) => {
    return api.post(
      '/export',
      {
        filters: Object.keys(filters).length > 0 ? filters : {},
        orderBy,
        orderDir,
        page: p,
        fields: undefined,
        perPage: parseInt(perPage),
      },
      {
        responseType: 'blob',
      }
    );
  };

  autoSuggest = (value) => {
    return api.post('/search', { filters: { displayName: value }, perPage: 20, page: 1 });
  };
}

const instance = new VReportsCommission();
Object.freeze(instance);

export default instance;
